<script>
    const info = [
        {
            image: 'images/Lighting.png',
            number: '01',
            name: 'Lighting',
        },
        {
            image: 'images/Camera.png',
            number: '02',
            name: 'Camera Control',
        },
        {
            image: 'images/Terrain.png',
            number: '03',
            name: 'Terrain',
        },
        {
            image: 'images/Trees.png',
            number: '04',
            name: 'Trees. grass, flora.',
        },
        {
            image: 'images/House.png',
            number: '05',
            name: 'Houses & Buildings',
        },
        {
            image: 'images/Roads.png',
            number: '06',
            name: 'Roads',
        },
        {
            image: 'images/Humanoid.png',
            number: '07',
            name: 'Humanoid Characters',
        },
        {
            image: 'images/Animations.png',
            number: '08',
            name: 'Animations',
        },
    ];
    const animate = [
        {
            gif: 'images/landingPage/videos/video1.mp4',
        },
        {
            gif: 'images/landingPage/videos/video2.mp4',
        },
        {
            gif: 'images/landingPage/videos/video3.mp4',
        },
    ];
    const socialInfo = [
        {
            icon: 'images/twiter.svg',
            name: '@OpusAIInc',
            link: 'https://twitter.com/OpusAIInc',
        },
        {
            icon: 'images/linkedin.svg',
            name: '@OpusAI',
            link: 'https://www.linkedin.com/company/opusai',
        },
        {
            icon: 'images/youtube.svg',
            name: '@OpusAI',
            link: 'https://www.youtube.com/c/opusai',
        },
        // {
        //     icon: 'images/discord.svg',
        //     name: 'Join Discord',
        //     link: 'https://discord.gg/Mz3t8NsN',
        // },
    ];
</script>

<div class="mainDiv">
    <div class="headingDiv">
        <h4>FEATURES</h4>
    </div>
    <div class="imgsection">
        {#each info as data}
            <div class="imgdiv">
                <div class="imgcss">
                    <img src={data.image} alt="" width="100%" height="100%" />
                </div>
                <div class="textDiv">
                    <div class="number">
                        <p>{data.number}</p>
                    </div>
                    <div class="number">
                        <p>{data.name}</p>
                    </div>
                </div>
            </div>
        {/each}
    </div>
    <div class="lastSection">
        <div class="keep">
            <p>KEEP UP TO DATE</p>
        </div>
        <div style="display: flex;    margin-top: 2.778vh;">
            <div class="Follow">
                <p>FOLLOW US</p>
            </div>
            <div class="community">
                <h4>
                    The latest from <br />
                    Opus community
                </h4>
            </div>
        </div>
        <div class="gifDiv">
            {#each animate as data}
                <div class="gifimg">
                    <video width="100%" height="100%"  autoplay loop muted>
                        <source src= {data.gif} type="video/mp4">
                    </video>
                </div>
            {/each}
        </div>
        {#each socialInfo as info}
         <a href={info.link} target="_blank" rel="noreferrer">
            <div class="socialDiv">
                <div class="icon">
                    <img src={info.icon} alt="" width="100%" height="100%" />
                </div>
                <div class="link">
                    <p>{info.name}</p>
                </div>
            </div>
        </a>
        {/each}
    </div>
</div>

<style>
    .mainDiv {
        position: relative;
        font-family: "Orbitron";
        display: flex;
        height: 100vh;
    }
    .imgsection {
        background-color: #f4eeec;
        padding-top: 18.519vh;
        padding-left: 3.426vh;
        padding-right: 18.519vh;
        display: flex;
    }
    .imgdiv {
        position: relative;
        width: 54.444vh;
        height: 67.593vh;
        background-color: white;
        margin-right: 4.63vh;
        padding: 3.519vh 3.519vh 0vh;
        box-shadow: 0vh 0.37vh 2.963vh rgba(0, 0, 0, 0.25);
    }
    .imgdiv::after {
        content: "";
        position: absolute;
        width: 19.074vh;
        height: 10.4vh;
        background-color: inherit;
        left: 20vh;
        top: 71.112vh;
    }
    .imgcss {
        height: 53.519vh;
        width: 100%;
        overflow: hidden;
    }
    .imgcss::after{
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 0, 0, 0)(255, 255, 255);
    }
    .imgdiv:nth-child(1) .imgcss img {
        transition: 0.75s ease;
        transform: scale(1.2) translate(-28vh, 1vh);
        width: 89vh;
        height: auto;
    }
    .imgdiv:nth-child(1):hover .imgcss img {
        transform: scale(1.05) translate(3vh, -1vh);
    }
    .imgdiv:nth-child(2) .imgcss img {
        transition: 0.75s ease;
        transform: scale(0.55) translate(-130vh, -43vh);
        width: auto;
        height: 100vh;
    }
    .imgdiv:nth-child(2):hover .imgcss img {
        transform: scale(0.55) translate(-90vh, -43vh);
    }
    .imgdiv:nth-child(3) .imgcss img {
        transition: 0.75s ease;
        transform: scale(0.58) translate(-64vh, -40vh);
        width: auto;
        height: 100vh;
    }
    .imgdiv:nth-child(3):hover .imgcss img {
        transform: scale(0.8) translate(-96vh, -37vh);
    }
    .imgdiv:nth-child(4) .imgcss img {
        transition: 0.75s ease;
        transform: scale(1) translate(-50vh, 0vh);
        width: 102vh;
        height: auto;
    }
    .imgdiv:nth-child(4):hover .imgcss img {
        transform: scale(1.47) translate(13vh, 0vh);
    }
    .imgdiv:nth-child(5) .imgcss img {
        transition: 0.75s ease;
        transform: scale(0.77) translate(-59vh, -20.5vh);
        width: 150vh;
        height: auto;
    }
    .imgdiv:nth-child(5):hover .imgcss img {
        transform: scale(1.24) translate(-40.8vh, -20vh);
    }
    .imgdiv:nth-child(6) .imgcss img {
        transition: 0.75s ease;
        transform: scale(1.69) translate(-15vh, 2vh);
        height: auto;
        width: 100vh;
    }
    .imgdiv:nth-child(6):hover .imgcss img {
        transform: scale(1.02) translate(-26vh, 1vh);
    }
    .imgdiv:nth-child(7) .imgcss img {
        transition: 0.75s ease;
        height: auto;
    }
    .imgdiv:nth-child(7):hover .imgcss img {
        transform: scale(1.4) translate(-3vh, -3.5vh);
    }
    .imgdiv:nth-child(8) .imgcss img {
        transition: 0.75s ease;
        transform: scale(0.61) translate(-74vh, -33vh);
        width: auto;
        height: 100vh;
    }
    .imgdiv:nth-child(8):hover .imgcss img {
        transform: scale(0.61) translate(-116vh, -32.3vh);
    }
    .headingDiv {
        background-color: black;
        width: 19.074vh;
        padding: 0vh 3.519vh;
    }
    .headingDiv h4 {
        margin: 0;
        color: black;
        font-size: 9.259vh;
        font-weight: 900;
        line-height: 9.259vh;
        text-transform: capitalize;
        -webkit-text-stroke: 0.185vh white;
        transform: rotate(-90deg);
        margin-top: 64vh;
    }
    .textDiv {
        display: flex;
        justify-content: space-between;
        margin-top: 1.204vh;
    }
    p {
        margin: 0;
    }
    .number {
        font-size: 2.778vh;
        color: #000000;
    }
    .lastSection {
        background-color: black;
        height:100vh;
        padding-left: 5.648vh;
        z-index: 10;
        position: relative;
    }
    .keep {
        width: 91.204vh;
        font-size: 1.111vh;
        color: white;
        margin-top: 18.519vh;
        text-transform: capitalize;
    }
    .Follow {
        font-size: 1.111vh;
        color: white;
        margin-top: 5.111vh;
        margin-bottom: 1.8vh;
        text-transform: capitalize;
        transform: rotate(-90deg);
    }
    .community h4 {
        margin: 0;
        font-weight: 900;
        font-size: 5.556vh;
        line-height: 5.556vh;
        color: #ffffff;
        border: 0.093vh solid #000000;
    }
    .gifDiv {
        padding-left: 5.833vh;
        display: flex;
        margin-top: 6.667vh;
        padding-bottom: 7.6vh;
    }
    .gifimg {
        width: 23.333vh;
        height: 23.333vh;
        margin-right: 3.611vh;
    }
    /* .gifimg img {
        object-fit: cover;
    } */
    .socialDiv {
        margin-left: 5.833vh;
        padding: 1.759vh 0vh;
        width: 33.981vh;
        border-top: 0.093vh solid #fff;
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .icon {
        width: 5.556vh;
    }
    .icon img {
        width: 2.778vh;
    }
    .link {
        font-size: 1.111vh;
        color: white;
        text-transform: capitalize;
    }
</style>
